import { Component, OnInit } from '@angular/core';

import { ApiTokenService } from '../../../core/api/services/api-token.service';
import { KeyValueModel } from '../../../core/models/key-value.model';
import { BaseSelectSearch } from './base/base-select-search.component';
import { BaseSelectSearchModule } from './base/base-select.search.module';

@Component({
    selector: 'get-apis-select-search',
    templateUrl: './base/base-select-search-template.html',
    imports: [BaseSelectSearchModule]
})
export class GetApisSelectSearchComponent
  extends BaseSelectSearch
  implements OnInit
{
  getApisValues: KeyValueModel[] = [];

  constructor(protected currentService: ApiTokenService) {
    super();
  }

  initConfig() {
    this.optionValue = 'value';
    this.optionTitle = 'key';
  }

  getItemsApi() {
    this.currentService
      .apiTokenGetApis()
      .pipe(this.basePipeOperators())
      .subscribe({
        next: (items) => {
          this.items = [];
          for (const api in items?.data) {
            let getApi: KeyValueModel = {};
            getApi.key = api;
            getApi.value = items?.data[api];
            this.items.push(getApi);
          }
          this.setDefaultValue();
        },
        error: (error) => {
          this.emitError();
        },
      });
  }
}
